import type { IDocumentItemProps, IDocumentsInfo, IDocumentsInfoStoreData } from '../../interfaces';
import { DocumentItem } from '../DocumentItem';

const mapToDocumentItemProps = (
  documentStoreData: IDocumentsInfoStoreData,
  canDelete: boolean,
  isShowApprovalState: boolean,
  deleteConfirmationRequired: boolean,
  removeDocument?: (documentId: number) => void,
): IDocumentItemProps => {
  const document: IDocumentsInfo = {
    approval: documentStoreData.approval,
    documentId: documentStoreData.documentId,
    fileName: documentStoreData.fileName ?? '',
    fileSize: documentStoreData.fileSize,
  };

  return {
    document,
    canDelete,
    isShowApprovalState,
    onDocumentRemove: removeDocument,
    isDeleteConfirmationRequired: deleteConfirmationRequired || false,
  };
};

const getFilesInProgress = (filesInProgress: IDocumentItemProps[], removeFile?: (fileKey: number) => void) => {
  const filesItems = filesInProgress.map((document) => ({
    ...document,
    onDocumentRemove: removeFile,
  }));

  return filesItems;
};

const isDocumentPending = (document: IDocumentsInfoStoreData): boolean =>
  !document.approval || document.approval.approvalState === 'Pending';

const renderDocumentItem = (documentProps: IDocumentItemProps, key: number) => (
  <DocumentItem
    key={key}
    {...documentProps}
  />
);

export { mapToDocumentItemProps, getFilesInProgress, isDocumentPending, renderDocumentItem };
